import { useState } from "react";
import { toast } from "sonner";
import { useRemoveMarketplace } from "@/api/mutations/plugins";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import type { Marketplace } from "@/types";

// #290 (Review-Fund): EIN Remove-Dialog für Liste UND Marketplace-Detail — vorher zwei
// wörtliche Kopien mit asymmetrischem Verhalten: die Liste setzte die „Repository ebenfalls
// löschen"-Checkbox beim Schließen zurück, das Detail nie → nach Abbrechen+Neu-Öffnen war
// die destruktive Option unbemerkt vorbelegt.
export function RemoveMarketplaceDialog({
  marketplace,
  open,
  onOpenChange,
  onRemoved,
}: {
  marketplace: Pick<Marketplace, "id" | "name" | "origin">;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRemoved?: () => void;
}) {
  const remove = useRemoveMarketplace();
  const [repoToo, setRepoToo] = useState(false);

  function close(o: boolean) {
    onOpenChange(o);
    if (!o) setRepoToo(false); // destruktive Option NIE über ein Abbrechen hinweg merken
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={close}
      title="Marketplace entfernen"
      description={`"${marketplace.name}" wird entfernt — inkl. aller Freigaben und Zuweisungen. Bei allen Agents werden diese Plugins deinstalliert.`}
      confirmText="Entfernen"
      confirmVariant="destructive"
      requiredTypeText={marketplace.name}
      isPending={remove.isPending}
      onConfirm={() => {
        remove.mutate({ id: marketplace.id, deleteRepo: repoToo }, {
          onSuccess: () => {
            toast.success(`"${marketplace.name}" entfernt`);
            close(false);
            onRemoved?.();
          },
          onError: (err) => toast.error(`Entfernen fehlgeschlagen: ${(err as Error).message}`),
        });
      }}
    >
      {/* nur bei EIGENEN Katalogen anbieten — bei fremden Quellen gibt es kein Repo bei
          uns, das verwaisen könnte */}
      {marketplace.origin === "own" && (
        <label className="flex cursor-pointer items-center gap-2 text-[12.5px] text-text2">
          <input
            type="checkbox"
            checked={repoToo}
            onChange={(e) => setRepoToo(e.target.checked)}
            data-testid="remove-repo-too"
          />
          Repository ebenfalls löschen (wird archiviert — sonst bleibt es unsichtbar zurück)
        </label>
      )}
    </ConfirmDialog>
  );
}
